<script>
import Swal from "sweetalert2";

// Custom components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Hotel List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Hotel List",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Hotels",
          active: true,
        },
      ],
      addEditIntent: false,
      openNewRequestForm: false,
      isEdit: false,
      tableData: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      hotelList: [],
      addHotelLoading: false,
      errorMessage: "",
      avatarData: [],
      tempHotelData: [],
      avatarImg: "",
      sortKey: "name",
      reverse: false,
      search: "",
      sortedbyASC: true,
    };
  },
  components: {
    PageHeader,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getListOfIntents();
    this.getListOfAvatar();
  },
  methods: {
    // Get list of all avatar
    async getListOfAvatar() {
      await UserService.getBotAvatarList().then((response) => {
        this.avatarData = response.avatarList;
      });
    },

    // Get list of all intents
    async getListOfIntents() {
      this.isDataLoading = true;
      let tempHotelData = [];

      await UserService.getVideoChatHotelList()
        .then(async (res) => {
          tempHotelData = res.hotelList;
          await UserService.getHotelsList().then((result) => {
            result.results.map((item) => {
              if (
                tempHotelData.length > 0 &&
                tempHotelData.some(
                  (hotelData) => hotelData.hotel_id === item.id
                )
              ) {
                UserService.getVideoChatHotelDetails(item.id).then(
                  (hotelDetails) => {
                    this.tableData.push({
                      id: item.id,
                      name: item.name,
                      avatar_img: hotelDetails.photo
                        ? "https://vod-lex-files.s3.amazonaws.com/" +
                          hotelDetails.photo
                        : " ",
                      avatar_name: hotelDetails.name ? hotelDetails.name : "",
                      is_intent_add: true,
                    });
                  }
                );
              } else {
                this.tableData.push({
                  id: item.id,
                  name: item.name,
                  avatar_img: "",
                  avatar_name: "",
                  is_intent_add: false,
                });
              }
            });
          });
          this.isDataLoading = false;
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "danger");

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    async addIntentIntoHotel(data) {
      this.addHotelLoading = true;
      await UserService.getBotAvatarDetails(data.id)
        .then(async (avatar) => {
          let hotelData = {
            hotel_id: this.tempHotelData.id,
            hotel_name: this.tempHotelData.name,
            ...avatar,
          };
          await UserService.addVideoChatHotel(hotelData).then(async (res) => {
            this.$refs["avatar_selection_modal"].hide();

            this.addHotelLoading = false;
            Middleware.notification(
              "Successfully added hotel & intent !!",
              "success"
            );

            this.tableData = this.tableData.map((table) => {
              if (table.id === this.tempHotelData.id) {
                table.is_intent_add = true;
              }
              return table;
              //   });
              // });
            });
          });
        })
        .catch((error) => {
          this.addHotelLoading = false;
          this.isDataLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "error");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    async deleteHotel(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteVideoChatHotel(data)
            .then((response) => {
              this.tableData = this.tableData.map((table) => {
                if (table.id === data) {
                  table.is_intent_add = false;
                }
                return table;
              });
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
              Middleware.notification("Something went wrong !!", "error");

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      });
    },

    redirectHotelIntestListPage(id) {
      this.$router.push({
        path: "/video-bot",
        query: {
          hotel: id,
        },
      });
    },

    selectAvatarForHotel(data) {
      this.tempHotelData = data;
      this.$refs["avatar_selection_modal"].show();
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" :isButton="false" />

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th>Avatar</th>
                <th @click="sortList('id')">Hotel ID &#8597;</th>
                <th @click="sortList('name')">Hotel Name &#8597;</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 4" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(data, index) in tableData" :key="data.id">
                <td>
                  <img
                    v-if="data.avatar_img"
                    :src="data.avatar_img"
                    alt=""
                    class="avatar-md rounded-circle img-thumbnail object-fit"
                  />
                  - {{ data.avatar_name }}
                </td>
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.id }}
                </td>
                <td class="text-wrap">
                  {{ data.name }}
                </td>

                <td>
                  <span v-if="!data.is_intent_add">
                    <i
                      @click="selectAvatarForHotel(data)"
                      class="fas fa-plus-circle mx-1 fs-4 text-primary"
                    ></i>
                    <!-- @click="addIntentIntoHotel(data)" -->
                  </span>
                  <span v-else>
                    <i
                      @click="redirectHotelIntestListPage(data.id)"
                      class="far fa-edit mx-1 fs-5 text-primary"
                    ></i>
                  </span>
                  <span v-show="data.is_intent_add">
                    <i
                      @click="deleteHotel(data.id)"
                      class="far fa-trash-alt mx-1 fs-5 text-danger"
                    ></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-"
      size="xl"
      ref="avatar_selection_modal"
      title="Select Avatar"
      title-class="font-18"
      headerClass="justify-content-center"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-3 mx-auto" v-for="data in avatarData" :key="data.id">
          <div class="card">
            <div class="card-body text-center">
              <div class="">
                <img
                  :src="'https://vod-lex-files.s3.amazonaws.com/' + data.photo"
                  alt=""
                  class="avatar-lg rounded-circle img-thumbnail object-fit"
                />
                <div class="text-muted">
                  <h5>{{ data.name }}</h5>
                  <div
                    class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
                    role="status"
                    v-show="addHotelLoading"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="addIntentIntoHotel(data)"
                    v-show="!addHotelLoading"
                  >
                    Select
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
